import { withProductShop } from "../shops/productShop";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { elakay_API } from "../../config";
import PreViewProduct from '../slider/ProdViewSlider/slider';
import Vote from './commentaire/vote';
import Modal from 'react-bootstrap/Modal';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Price from "./productsPrice";
import CommentaireUser from './commentaire/comentairePro';
import { MdClose, MdInfo, MdDescription, MdOpenInNew } from "react-icons/md";
import './ModalProdView.css';

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["modalProductView"]?.[key] || fallback;

const AddCartFilter = (a = [], n, f) => {
    return a?.filter(item => item?.filter[f] == n) || [];
};

function removeNotSpecified(obj) {
    for (const key in obj) {
        if (obj[key] === "Not Specified") {
            delete obj[key];
        }
    }
    return obj;
}

const objToArr = (a) => {
    a = removeNotSpecified(a);
    return a && { v: Object.values(a) || [], k: Object.keys(a) || [] };
};

const ModalProdView = (props) => {
    const {
        infoSource,
        setShowListe,
        showListe,
        productV,
        image,
        skip,
        limit,
        voteA = [],
        comments,
        productId,
        token,
        setCommentsPro,
        SetSizeComments,
        setUserVote,
        setShowComments,
        commentProduct,
        loadProductsView,
        ButtonAddComments,
        showComments,
    } = props;
    __setElakayInfoSource(infoSource);
    const { getButtonTitle } = infoSource;

    const [key, setKey] = useState('details');

    const {
        filter = [],
        values,
        filterColor
    } = productV;
    const productPreviewUrl = withProductShop(`/product/preview/${productId}${filterColor ? `?color=${filterColor}` : ''}`, { _id: props.shopId });

    // Calculate rating
    const sum = (total, num) => total + Math.round(num);
    const sumVote = voteA?.map((p) => p.voteNum);
    const ratingVote = parseFloat(sumVote.reduce(sum, 0) / voteA?.length);

    let selectFilter = AddCartFilter(filter, filterColor, 'color')[0]
        ? AddCartFilter(filter, filterColor, 'color')[0]?.filter
        : filter[0] && filter[0]?.filter;
    let arrayFilter = objToArr(selectFilter);

    const StarRating = () => (
        <div className="modal-star-rating">
            {ratingVote ? (
                <Vote rating={ratingVote} />
            ) : (
                <Vote rating={0} />
            )}
        </div>
    );

    const FilterDetailsTable = () => (
     <div className="fd-wrap">
        {arrayFilter && arrayFilter.k?.map((key, i) => (
            <div
                key={i}
                className={`fd-row ${i % 2 === 1 ? 'alt' : ''}`}
            >
                <span className="fd-key">{key}</span>
                <span className="fd-val">{arrayFilter.v[i]}</span>
            </div>
        ))}
    </div>
    );

    const ImageSlider = () => (
        <div className="modal-image-slider">
            <PreViewProduct slides={[image]} options={{}} infoSource={infoSource} />
        </div>
    );
const ProductDetails = () => (
    <div className="pd-wrap">

        {/* ── Tabs ── */}
        <div className="pd-tabs">
            <button
                className={`pd-tab ${key === 'details' ? 'on' : ''}`}
                onClick={() => setKey('details')}
            >
                <MdInfo className="pd-tab-icon" />{__elakayText("t002", "Details")}</button>
            <button
                className={`pd-tab ${key === 'description' ? 'on' : ''}`}
                onClick={() => setKey('description')}
            >
                <MdDescription className="pd-tab-icon" />{__elakayText("t003", "Description")}</button>
        </div>

        {/* ── Content ── */}
        <div className="pd-body">
            {key === 'details' && (
                <div className="pd-panel">
                    <FilterDetailsTable />
                </div>
            )}
{key === 'description' && (
    <div className="pd-panel">

        {/* HTML injecté — values.description */}
        <div
            className="pd-desc-html"
            dangerouslySetInnerHTML={{ __html: values?.description }}
        />

        {/* Notes depuis values.note — avec dangerouslySetInnerHTML sur description */}
        {values?.note?.length > 0 &&
            values.note.map((k, j) =>
                k.tilte ? (
                    <div key={`val-${j}`} className="pd-note-item">
                        <div className="pd-note-title">{k.tilte}</div>
                        <div
                            className="pd-note-body"
                            dangerouslySetInnerHTML={{ __html: k.description }}
                        />
                    </div>
                ) : null
            )
        }

    </div>
)}
        </div>
    </div>
);

    const ProductInfo = () => (
        <div className="modal-product-info">
            <StarRating />
            
            <div className="product-info-content">
                <h2
                    className="product-title"
                    dangerouslySetInnerHTML={{ __html: values?.name }}
                />
                
                <div
                    className="product-short-description"
                    dangerouslySetInnerHTML={{ __html: values?.description }}
                />

                <div className="product-price-section">
                    <Price
                        showAddToCartButton={false}
                        products={values}
                    />
                </div>

                <Link
                    to={productPreviewUrl}
                    className="modal-view-product-link"
                    onClick={() => setShowListe(false)}
                >
                    <MdOpenInNew className="pd-tab-icon" />{getButtonTitle("viewProduct")}
                </Link>
            </div>
        </div>
    );

    const ProductView = () => (
        <div className="modal-product-view">
            <div className="product-view-grid">
                <div className="product-view-image">
                    <ImageSlider />
                </div>
                <div className="product-view-info">
                    <ProductInfo />
                </div>
            </div>

            <div className="product-view-details">
                <ProductDetails />
            </div>

            {comments && (
                <div className="product-view-comments">
                    <CommentaireUser
                        infoSource={infoSource}
                        skip={skip}
                        limit={limit}
                        voteA={voteA}
                        comments={comments}
                        productId={productId}
                        token={token}
                        setCommentsPro={setCommentsPro}
                        SetSizeComments={SetSizeComments}
                        setUserVote={setUserVote}
                        setShowComments={setShowComments}
                        commentProduct={commentProduct}
                        loadProductsView={loadProductsView}
                        ButtonAddComments={ButtonAddComments}
                        showComments={showComments}
                    />
                </div>
            )}
        </div>
    );

    return (
        <Modal
            size="xl"
            show={showListe}
            onHide={() => setShowListe(false)}
            dialogClassName="modal-product-dialog"
            className="modal-product-container"
            centered
        >
            <div className="modal-product-wrapper">
                <button
                    className="modal-close-button"
                    onClick={() => setShowListe(false)}
                    aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).modalProductView.t001}
                >
                    <MdClose />
                </button>

                <ProductView />
            </div>
        </Modal>
    );
};

export default ModalProdView;